export const pricing = {
  'pricing.title': 'Tarifs simples et transparents',
  'pricing.subtitle': 'Choisissez le plan qui correspond à vos besoins.',
  'pricing.popular': 'Populaire',
  'pricing.contact': 'Des questions ? Contactez-nous pour en savoir plus sur nos offres.',

  // ======================
  // PAY-AS-YOU-GO PLANS (Simulators)
  // ======================

  // Individual (Particuliers)
  'pricing.payg.individual.name': 'Particulier',
  'pricing.payg.individual.price': '2,99€',
  'pricing.payg.individual.description': 'Paiement unique - Valable 1 an',
  'pricing.payg.individual.feature1': '5 utilisations (chatbot + calculateur)',
  'pricing.payg.individual.feature2': 'Calcul MaPrimeRénov\', CEE, Éco-PTZ',
  'pricing.payg.individual.feature3': 'Assistant IA pour trouver vos aides',
  'pricing.payg.individual.feature4': 'Résultats instantanés',
  'pricing.payg.individual.cta': 'Acheter maintenant',

  // Entrepreneur
  'pricing.payg.entrepreneur.name': 'Entrepreneur',
  'pricing.payg.entrepreneur.price': '9,99€',
  'pricing.payg.entrepreneur.description': 'Paiement unique - Valable 1 an',
  'pricing.payg.entrepreneur.feature1': '5 utilisations (chatbot + calculateur)',
  'pricing.payg.entrepreneur.feature2': 'Recherche de subventions entreprise',
  'pricing.payg.entrepreneur.feature3': 'Assistant IA personnalisé',
  'pricing.payg.entrepreneur.feature4': 'Export des résultats PDF',
  'pricing.payg.entrepreneur.cta': 'Acheter maintenant',

  // Consultant
  'pricing.payg.consultant.name': 'Consultant',
  'pricing.payg.consultant.price': '14,99€',
  'pricing.payg.consultant.description': 'Paiement unique - Valable 1 an',
  'pricing.payg.consultant.feature1': '5 utilisations (chatbot + calculateur)',
  'pricing.payg.consultant.feature2': 'Utilisation pour vos clients',
  'pricing.payg.consultant.feature3': 'Rapport professionnel',
  'pricing.payg.consultant.feature4': 'Support prioritaire',
  'pricing.payg.consultant.cta': 'Acheter maintenant',

  // ======================
  // ⚠️ DEPRECATED - OLD SUBSCRIPTION PLANS ⚠️
  // These are kept for backwards compatibility only.
  // The CORRECT pricing is volume-based (see TarifsPage section below).
  // Real pricing: €29/month for 1-10 clients, €59 for 11-25, etc.
  // ======================

  // Solo Plan - DEPRECATED (replaced by volume-based €29/month for 1-10 clients)
  'pricing.solo.name': 'Solo',
  'pricing.solo.price': '29€/mois',
  'pricing.solo.description': 'Pour les entrepreneurs individuels',
  'pricing.solo.feature1': '1 Profil Entreprise',
  'pricing.solo.feature2': 'Recherches de subventions illimitées',
  'pricing.solo.feature3': 'Matching IA intelligent',
  'pricing.solo.feature4': 'Base de données 50,000+ aides',
  'pricing.solo.feature5': 'Suivi des candidatures',
  'pricing.solo.feature6': 'Alertes personnalisées',
  'pricing.solo.cta': 'Commencer',

  // ⚠️ DEPRECATED - All plans below use OLD pricing.
  // CORRECT pricing from TarifsPage: €29 (1-10), €59 (11-25), €99 (26-50), €179 (51-100), €399 (101-250), etc.

  // Pro 10 Plan - DEPRECATED (now €29/month for 1-10 clients)
  'pricing.pro10.name': '1-10 clients',
  'pricing.pro10.price': '29€/mois',
  'pricing.pro10.pricePerClient': '2,90€ par client',
  'pricing.pro10.description': 'Jusqu\'à 10 profils clients',
  'pricing.pro10.feature1': 'Jusqu\'à 10 Profils Entreprise',
  'pricing.pro10.feature2': 'Fonctionnalités complètes',
  'pricing.pro10.feature3': 'Gestion multi-clients',
  'pricing.pro10.feature4': 'Tableau de bord consultant',
  'pricing.pro10.feature5': 'Rapports personnalisés',
  'pricing.pro10.cta': 'Commencer',

  // Pro 20 Plan - DEPRECATED (now part of 11-25 tier at €59/month)
  'pricing.pro20.name': '11-25 clients',
  'pricing.pro20.price': '59€/mois',
  'pricing.pro20.pricePerClient': '2,36€ par client',
  'pricing.pro20.description': 'Jusqu\'à 25 profils clients',
  'pricing.pro20.feature1': 'Jusqu\'à 25 Profils Entreprise',
  'pricing.pro20.feature2': 'Tout inclus',
  'pricing.pro20.feature3': 'Opérations en masse',
  'pricing.pro20.feature4': 'Exports groupés',
  'pricing.pro20.feature5': 'Support prioritaire',
  'pricing.pro20.cta': 'Commencer',

  // Pro 40 Plan - DEPRECATED (now part of 26-50 tier at €99/month)
  'pricing.pro40.name': '26-50 clients',
  'pricing.pro40.price': '99€/mois',
  'pricing.pro40.pricePerClient': '1,98€ par client',
  'pricing.pro40.description': 'Jusqu\'à 50 profils clients',
  'pricing.pro40.feature1': 'Jusqu\'à 50 Profils Entreprise',
  'pricing.pro40.feature2': 'Tout inclus',
  'pricing.pro40.feature3': 'Automatisations avancées',
  'pricing.pro40.feature4': 'API d\'intégration',
  'pricing.pro40.feature5': 'Gestionnaire de compte dédié',
  'pricing.pro40.cta': 'Commencer',

  // Pro 80 Plan - DEPRECATED (now part of 51-100 tier at €179/month)
  'pricing.pro80.name': '51-100 clients',
  'pricing.pro80.price': '179€/mois',
  'pricing.pro80.pricePerClient': '1,79€ par client',
  'pricing.pro80.description': 'Jusqu\'à 100 profils clients',
  'pricing.pro80.feature1': 'Jusqu\'à 100 Profils Entreprise',
  'pricing.pro80.feature2': 'Tout inclus',
  'pricing.pro80.feature3': 'Gestion d\'équipe illimitée',
  'pricing.pro80.feature4': 'Formation personnalisée',
  'pricing.pro80.feature5': 'Support téléphonique',
  'pricing.pro80.cta': 'Commencer',

  // Pro 150 Plan - DEPRECATED (now part of 101-250 tier at €399/month)
  'pricing.pro150.name': '101-250 clients',
  'pricing.pro150.price': '399€/mois',
  'pricing.pro150.pricePerClient': '1,60€ par client',
  'pricing.pro150.description': 'Jusqu\'à 250 profils clients',
  'pricing.pro150.feature1': 'Jusqu\'à 250 Profils Entreprise',
  'pricing.pro150.feature2': 'Tout inclus',
  'pricing.pro150.feature3': 'Gestion d\'équipe illimitée',
  'pricing.pro150.feature4': 'Personnalisation complète',
  'pricing.pro150.feature5': 'SLA 99,9%',
  'pricing.pro150.cta': 'Commencer',

  // Pro 300 Plan - DEPRECATED (now part of 251-500 tier at €699/month)
  'pricing.pro300.name': '251-500 clients',
  'pricing.pro300.price': '699€/mois',
  'pricing.pro300.pricePerClient': '1,40€ par client',
  'pricing.pro300.description': 'Jusqu\'à 500 profils clients',
  'pricing.pro300.feature1': 'Jusqu\'à 500 Profils Entreprise',
  'pricing.pro300.feature2': 'Tout inclus',
  'pricing.pro300.feature3': 'Déploiement dédié',
  'pricing.pro300.feature4': 'Intégrations personnalisées',
  'pricing.pro300.feature5': 'Chef de projet dédié',
  'pricing.pro300.cta': 'Nous contacter',

  // Pro 500 Plan - DEPRECATED (now part of 501-1000 tier at €1,199/month)
  'pricing.pro500.name': '501-1000 clients',
  'pricing.pro500.price': '1 199€/mois',
  'pricing.pro500.pricePerClient': '1,20€ par client',
  'pricing.pro500.description': 'Jusqu\'à 1000 profils clients',
  'pricing.pro500.feature1': 'Jusqu\'à 1000 Profils Entreprise',
  'pricing.pro500.feature2': 'Tout inclus',
  'pricing.pro500.feature3': 'Infrastructure dédiée',
  'pricing.pro500.feature4': 'Développements sur-mesure',
  'pricing.pro500.feature5': 'Formation continue',
  'pricing.pro500.cta': 'Nous contacter',

  // Enterprise 1000+ Plan - DEPRECATED (now 1001-2000 at €2,299/month)
  'pricing.enterprise.name': '1001+ clients',
  'pricing.enterprise.price': '2 299€/mois',
  'pricing.enterprise.pricePerClient': '1,15€ par client',
  'pricing.enterprise.description': 'Plus de 1000 profils clients',
  'pricing.enterprise.feature1': '1000+ Profils Entreprise',
  'pricing.enterprise.feature2': 'Tout inclus',
  'pricing.enterprise.feature3': 'Serveurs dédiés',
  'pricing.enterprise.feature4': 'Contrat d\'entreprise personnalisé',
  'pricing.enterprise.feature5': 'Support 24/7',
  'pricing.enterprise.feature6': 'Conformité sur-mesure',
  'pricing.enterprise.cta': 'Nous contacter',

  // ======================
  // PAGE TARIFS AU VOLUME (TarifsPage)
  // ======================

  // SEO
  'pricing.page.seo.title': 'Tarifs subvention360 - Facturation au volume de clients actifs',
  'pricing.page.seo.description': 'Tarifs transparents conçus pour les professionnels du conseil. Payez uniquement pour votre activité réelle chaque mois. De €49/mois (1-5 clients) à €4 499/mois (1201-2500 clients). Tarifs dégressifs automatiques.',
  'pricing.page.seo.keywords': 'tarifs subvention360, prix plateforme subventions, facturation clients actifs, pricing consultants, tarifs dégressifs, cabinet conseil, expert-comptable',

  // Section Hero
  'pricing.page.hero.heading': 'Tarifs conçus pour les professionnels du conseil, de l\'audit et de l\'expertise comptable',
  'pricing.page.hero.subheading': 'Payez uniquement pour votre activité réelle, chaque mois',
  'pricing.page.hero.description': 'Notre engagement :<br/>Une facturation simple et prévisible basée sur vos <strong>clients actifs</strong> mensuels.<br/>• Prélèvement automatique sécurisé le <strong>5 du mois suivant</strong>',
  'pricing.page.hero.additionalInfo': '• Tarifs dégressifs automatiques selon votre croissance<br/>• Un seul abonnement pour toute votre équipe — collaborateurs illimités inclus',
  'pricing.page.hero.badge1': 'Aucun engagement',
  'pricing.page.hero.badge2': 'Annulation à tout moment',
  'pricing.page.hero.badge3': 'Pas d\'abonnement minimum',

  // Section Abonnement Unique
  'pricing.page.team.title': 'Une facturation unique pour toute votre équipe',
  'pricing.page.team.feature1': '<strong>Collaboration illimitée sans frais supplémentaires</strong> — Ajoutez tous vos collaborateurs sans restriction. Consultants, associés, assistants - tous inclus. Aucune limite sur le nombre de comptes utilisateurs.',
  'pricing.page.team.feature2': '<strong>Facturation centralisée et simplifiée</strong> — Basée uniquement sur votre volume de clients actifs mensuels. Une seule facture pour toute votre organisation. Indépendante du nombre d\'utilisateurs.',
  'pricing.page.team.feature3': '<strong>Environnement collaboratif intégré</strong> — Votre équipe entière travaille en parfaite synchronisation. Accès immédiat à toutes les fonctionnalités premium. Données et rapports partagés en temps réel.',
  'pricing.page.team.important': '<strong>Important :</strong> Vous ne payez que pour le nombre de clients actifs dans votre plateforme chaque mois.',

  // Grille Tarifaire
  'pricing.page.grid.title': 'Économisez jusqu\'à 69% par client en développant votre activité',
  'pricing.page.grid.subtitle': '<strong>Calcul de votre volume mensuel :</strong><br/>Nous prenons en compte l\'ensemble de vos clients (existants et nouveaux) dans la plateforme chaque mois.<br/><br/>Les suppressions de clients sont appliquées dès le mois suivant, vous permettant d\'ajuster rapidement votre volume.',
  'pricing.page.grid.header.clients': 'Volume clients actifs',
  'pricing.page.grid.header.monthlyPrice': 'Prix mensuel HT',
  'pricing.page.grid.header.pricePerClient': 'Prix indicatif par client',
  'pricing.page.grid.header.idealFor': 'Tarif dégressif',

  // Paliers Tarifaires - Labels "Tarif dégressif automatique" (Updated December 2025)
  'pricing.page.tier.1-5.idealFor': '—',
  'pricing.page.tier.6-10.idealFor': 'Économie de 19%',
  'pricing.page.tier.11-20.idealFor': 'Économie de 34%',
  'pricing.page.tier.21-35.idealFor': 'Économie de 45%',
  'pricing.page.tier.36-60.idealFor': 'Économie de 54%',
  'pricing.page.tier.61-120.idealFor': 'Économie de 62%',
  'pricing.page.tier.121-300.idealFor': 'Économie de 69%',
  'pricing.page.tier.301-600.idealFor': 'Économie de 73%',
  'pricing.page.tier.601-1200.idealFor': 'Économie de 79%',
  'pricing.page.tier.1201-2500.idealFor': 'Économie de 82%',

  // Cartes Tarifaires (Mobile)
  'pricing.page.card.clients': 'clients',
  'pricing.page.card.monthlyPrice': 'Prix mensuel',
  'pricing.page.card.perClient': 'Par client',

  // Section Économies (Updated December 2025)
  'pricing.page.savings.title': 'Économies automatiques avec la croissance',
  'pricing.page.savings.tier1': '5 clients',
  'pricing.page.savings.tier1Price': '€9,80 par client',
  'pricing.page.savings.tier2': '120 clients',
  'pricing.page.savings.tier2Price': '€3,74 par client <span className="text-green-600 font-semibold">(-62%)</span>',
  'pricing.page.savings.tier3': '2,500 clients',
  'pricing.page.savings.tier3Price': '€1,80 par client <span className="text-green-600 font-semibold">(-82%)</span>',

  // CTA
  'pricing.page.cta.button': 'Commencer maintenant',
  'pricing.page.cta.footer': 'Paiement sécurisé • Facturation mensuelle • Annulation à tout moment',

  // Comment Fonctionne la Facturation
  'pricing.page.billing.title': 'Fonctionnement de notre facturation au volume',
  'pricing.page.billing.subtitle': '',

  'pricing.page.billing.step1.title': 'Du 1er au dernier jour du mois',
  'pricing.page.billing.step1.description': 'Votre volume est calculé automatiquement basé sur vos clients Actifs dans la plateforme. Chaque client Actif dans le mois compte comme une unité.',

  'pricing.page.billing.step2.title': '1er du mois suivant',
  'pricing.page.billing.step2.description': 'Envoi par email de votre volume total et du montant à prélever. Transparence totale sur votre consommation mensuelle.',

  'pricing.page.billing.step3.title': '5 du mois',
  'pricing.page.billing.step3.description': 'Prélèvement automatique sécurisé du montant confirmé. Options : carte bancaire ou virement SEPA.',

  'pricing.page.billing.example.title': 'Exemple concret de facturation',
  'pricing.page.billing.example.description': '<strong>Scénario janvier :</strong><br/>• 5 janvier : Import de 200 clients → Volume = 200<br/>• 25 janvier : Suppression de 100 clients<br/>• Volume mensuel retenu : <strong>200 clients</strong><br/><br/><strong>Facturation février :</strong><br/>• Tranche applicable : 121-300 clients<br/>• Montant prélevé le 5 février : <strong>899€ HT</strong><br/>• Facturation alignée à votre activité réelle',

  // Section "Qu\'est-ce qui Compte" - REMOVED (no longer needed with active clients model)
  'pricing.page.counts.title': '',
  'pricing.page.counts.item1.title': '',
  'pricing.page.counts.item1.description': '',
  'pricing.page.counts.item2.title': '',
  'pricing.page.counts.item2.description': '',
  'pricing.page.counts.item3.title': '',
  'pricing.page.counts.item3.description': '',
  'pricing.page.counts.note': '',

  // Moyens de Paiement
  'pricing.page.payment.title': 'Moyens de Paiement',
  'pricing.page.payment.subtitle': 'Sécurisé et flexible',
  'pricing.page.payment.card.title': 'Carte Bancaire',
  'pricing.page.payment.card.description': 'Visa, Mastercard, American Express acceptés',
  'pricing.page.payment.card.badge': 'Instantané',
  'pricing.page.payment.sepa.title': 'Prélèvement SEPA',
  'pricing.page.payment.sepa.description': 'Prélèvement direct sur votre compte bancaire européen',
  'pricing.page.payment.sepa.badge': 'Préféré',
  'pricing.page.payment.invoice.title': 'Facture',
  'pricing.page.payment.invoice.description': 'Pour les volumes >1,000 clients/mois',
  'pricing.page.payment.invoice.badge': 'Enterprise',
  'pricing.page.payment.security': 'Tous les paiements sont sécurisés par Stripe, leader du marché en sécurité de paiement.',

  // FAQ
  'pricing.page.faq.title': 'Questions Fréquentes',
  'pricing.page.faq.q1': 'Puis-je changer de plan en cours de mois ?',
  'pricing.page.faq.a1': 'Oui, vous pouvez importer autant de clients que vous voulez. Vous serez facturé au palier correspondant en fin de mois.',
  'pricing.page.faq.q2': 'Que se passe-t-il si je dépasse mon palier ?',
  'pricing.page.faq.a2': 'Rien ! Vous passez automatiquement au palier suivant. La facturation s\'ajuste à votre volume réel.',
  'pricing.page.faq.q3': 'Puis-je annuler mon abonnement ?',
  'pricing.page.faq.a3': 'Oui, à tout moment. Il suffit de cesser d\'importer des clients. Vous ne payerez que pour le mois en cours.',
  'pricing.page.faq.q4': 'Y a-t-il des frais de mise en place ?',
  'pricing.page.faq.a4': 'Aucun frais de mise en place, aucun coût caché. Vous ne payez que pour vos imports de clients.',
  'pricing.page.faq.q5': 'Puis-je obtenir une facture ?',
  'pricing.page.faq.a5': 'Oui, vous recevez une facture détaillée le 5 de chaque mois avec le détail de vos imports.',
  'pricing.page.faq.q6': 'Pourquoi demandez-vous un RIB dès l\'inscription ?',
  'pricing.page.faq.a6': 'Nous demandons votre RIB pour : fluidifier votre expérience (pas de démarches ultérieures), valider votre statut professionnel (service réservé aux cabinets), et maintenir des tarifs avantageux. Rassurez-vous : aucun prélèvement sans votre accord explicite, contact systématique avant toute échéance, et votre compte reste accessible même sans abonnement.',

  // CTA Final
  'pricing.page.finalCta.title': 'Prêt à démarrer ?',
  'pricing.page.finalCta.subtitle': 'Créez votre compte en 30 secondes et commencez à identifier des subventions pour vos clients',
  'pricing.page.finalCta.button': 'Commencer maintenant',
  'pricing.page.finalCta.footer': 'Aucune carte bancaire requise pour l\'essai • Accès complet • Annulation à tout moment',
  'pricing.page.finalCta.backHome': 'Retour à l\'accueil',

  // Navigation (Header)
  'pricing.page.nav.features': 'Fonctionnalités',
  'pricing.page.nav.pricing': 'Tarifs',
  'pricing.page.nav.company': 'Entreprise',
  'pricing.page.nav.login': 'Connexion',
  'pricing.page.nav.trial': 'Essai',
  'pricing.page.nav.dashboard': 'Tableau de bord',

  // Section Hero - Compléments
  'pricing.page.hero.commitment': 'Notre engagement :',
  'pricing.page.hero.commitment.description': 'Une facturation simple et prévisible basée sur vos <strong>clients actifs</strong> mensuels.',
  'pricing.page.hero.commitment.bullet1': 'Prélèvement automatique sécurisé le <strong>5 du mois suivant</strong>',
  'pricing.page.hero.commitment.bullet2': 'Tarifs dégressifs automatiques selon votre croissance',
  'pricing.page.hero.commitment.bullet3': 'Un seul abonnement pour toute votre équipe — collaborateurs illimités inclus',

  // Explications Grille Tarifaire
  'pricing.page.grid.explanation1': 'Nous prenons en compte l\'ensemble de vos clients, Actifs et Nouveaux, dans la plateforme chaque mois.',
  'pricing.page.grid.explanation2': 'Les clients Inactifs et Suppressions sont appliqués dès le mois suivant, vous permettant d\'ajuster rapidement votre volume de facturation.',

  // Section Exemple de Facturation
  'pricing.page.billing.example.jan5': '5 janvier',
  'pricing.page.billing.example.jan5.action': 'Import de 200 clients',
  'pricing.page.billing.example.jan5.volume': 'Volume = 200',
  'pricing.page.billing.example.jan25': '25 janvier',
  'pricing.page.billing.example.jan25.action': 'Suppression de 100 clients',
  'pricing.page.billing.example.jan25.volume': 'Volume reste 200',
  'pricing.page.billing.example.feb5': '5 février',
  'pricing.page.billing.example.feb5.action': 'Tranche 121-300 clients',
  'pricing.page.billing.example.feb5.volume': 'Facturé 899€ HT',
  'pricing.page.billing.example.summary': '<strong>Avec 200 Créations et 100 Suppressions de clients en Janvier, votre compteur est à 100 clients Actifs au 1er Février.</strong>',
  'pricing.page.billing.example.note': 'Seuls les clients actifs au cours d\'un mois donné sont pris en compte dans la facturation. Vous n\'êtes pas tenu de supprimer un client : il suffit de le passer en statut inactif. Vous pourrez ainsi le réactiver à tout moment, sans devoir le recréer ni perdre les informations déjà renseignées dans sa fiche.',

  // Section Sécurité
  'pricing.page.security.title': 'Vos données en toute sécurité, votre sérénité garantie',
  'pricing.page.security.subtitle': 'Notre infrastructure certifiée protège vos informations les plus sensibles',

  'pricing.page.security.hosting.title': 'Hébergement souverain sécurisé',
  'pricing.page.security.hosting.item1': 'Serveurs européens certifiés SOC 2 Type 2',
  'pricing.page.security.hosting.item2': 'Infrastructure hébergée dans l\'Union Européenne (Francfort)',
  'pricing.page.security.hosting.item3': 'Sauvegardes automatiques multiples',

  'pricing.page.security.protection.title': 'Protection des données avancée',
  'pricing.page.security.protection.item1': 'Algorithmes AES-256 pour les données au repos',
  'pricing.page.security.protection.item2': 'Protocoles TLS 1.2+ pour les transferts sécurisés',
  'pricing.page.security.protection.item3': 'Authentification sécurisée par email et mot de passe',

  'pricing.page.security.compliance.title': 'Conformité réglementaire totale',
  'pricing.page.security.compliance.item1': 'Conformité RGPD complète',
  'pricing.page.security.compliance.item2': 'Respect des directives CNIL',
  'pricing.page.security.compliance.item3': 'Procédures d\'audit régulières (SOC 2 Type 2)',

  'pricing.page.security.privacy.title': 'Confidentialité absolue',
  'pricing.page.security.privacy.item1': 'Aucun partage de données avec des tiers',
  'pricing.page.security.privacy.item2': 'Pas de réutilisation de vos informations',
  'pricing.page.security.privacy.item3': 'Vos clients restent intégralement les vôtres',
} as const;
